import * as postMenuSearchV1 from 'api/menu/PostMenuSearchV1';

export default class Image {
	public url: string = '';
	public availableSizes: number[] | null = null;

	public constructor(input?: postMenuSearchV1.Image) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public mapFromApi(input: postMenuSearchV1.Image): void {
		this.url = input.url;
		this.availableSizes = input.availableSizes;
	}
}
